import { AnnouncementFlag } from '@domain'
import { useJsonVariation } from '@launchdarkly/react-sdk'
import dayjs from 'dayjs'

const validDate = (dateStr: string) => dayjs(dateStr, 'YYYY-MM-DDTHH:mm', true).isValid()

/**
 * Determines whether the announcement banner should be shown, and returns its message if so
 *
 * @returns {string | null} the announcement message, or null if it should not be shown
 */
export default function useAnnouncement() {
	const flag = useJsonVariation('announce', { enabled: false }) as AnnouncementFlag

	if (!flag.enabled || !flag.message) return null

	const now = dayjs()

	if (!validDate(flag.startDate) || !validDate(flag.endDate)) {
		console.error(
			`Invalid date format in announcement flag: startDate=${flag.startDate}, endDate=${flag.endDate}`
		)
		return null
	}

	if (flag.startDate && now.isBefore(dayjs(flag.startDate))) return null
	if (flag.endDate && now.isAfter(dayjs(flag.endDate))) return null

	return flag.message
}
